export const colors = {
  lightGray: "#e3e7dc",
  blueGreen: "#00494b",
  gray: "#36454b",
};

export const createClasses = (arg: any): { [className: string]: string } =>
  arg as { [className: string]: string };
